// import React from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import { useAuth } from "@/context/AuthContext";
// import {
//   LayoutDashboard, Users, HandCoins, GitBranch, Wallet, HeartHandshake,
//   Sparkles, LogOut, User as UserIcon, Receipt, Home, BarChart3, Download
// } from "lucide-react";

// const NAV_ADMIN = [
//   { to: "/admin", label: "Dashboard", icon: LayoutDashboard, testid: "nav-admin-dashboard" },
//   { to: "/admin/donors", label: "Donors", icon: Users, testid: "nav-admin-donors" },
//   { to: "/admin/donations", label: "Donations", icon: HandCoins, testid: "nav-admin-donations" },
//   { to: "/admin/projects", label: "Projects & Activities", icon: GitBranch, testid: "nav-admin-projects" },
//   { to: "/admin/utilizations", label: "Fund Utilization", icon: Wallet, testid: "nav-admin-utilizations" },
//   { to: "/admin/beneficiaries", label: "Beneficiaries", icon: HeartHandshake, testid: "nav-admin-beneficiaries" },
//   { to: "/admin/impact", label: "Impact Updates", icon: Sparkles, testid: "nav-admin-impact" },
// ];

// const NAV_DONOR = [
//   { to: "/donor", label: "Dashboard", icon: Home, testid: "nav-donor-dashboard" },
//   { to: "/donor/contributions", label: "My Contributions", icon: Receipt, testid: "nav-donor-contributions" },
//   { to: "/donor/impact", label: "My Impact", icon: Sparkles, testid: "nav-donor-impact" },
//   { to: "/donor/downloads", label: "Download Centre", icon: Download, testid: "nav-donor-downloads" },
//   { to: "/donor/profile", label: "My Profile", icon: UserIcon, testid: "nav-donor-profile" },
// ];

// export default function AppLayout({ children }) {
//   const { user, logout } = useAuth();
//   const nav = useNavigate();
//   const isAdmin = user?.role === "ADMIN";
//   const items = isAdmin ? NAV_ADMIN : NAV_DONOR;

//   return (
//     <div className="min-h-screen flex bg-background text-foreground">
//       <aside className="hidden md:flex md:w-72 flex-col border-r border-border bg-[#F7F4EF]/70 backdrop-blur">
//         <div
//           role="button"
//           tabIndex={0}
//           onClick={() => nav(isAdmin ? "/admin" : "/donor")}
//           className="px-6 py-6 border-b border-border cursor-pointer"
//           data-testid="brand-home-link"
//         >
//           <div className="overline mt-1 font-display text-0.5xl font-extrabold tracking-tight text-[hsl(160,84%,17%)]">DRMS<span className="text-[hsl(30,91%,44%)]">.</span>

//           </div>
//           {/* <div className="mt-1 font-display text-0.5xl font-extrabold tracking-tight text-[hsl(160,84%,17%)]">
//             DONOR RELATIONSHIP MANAGEMENT SYSTEM<span className="text-[hsl(30,91%,44%)]">.</span>
//           </div> */}
//           <div className="mt-1 font-display text-sm font-extrabold tracking-tight text-[hsl(160,84%,17%)]">
//             DONOR RELATIONSHIP MANAGEMENT SYSTEM
//             <span className="text-[hsl(30,91%,44%)]">.</span>
//           </div>
//           <div className="text-xs text-muted-foreground mt-1">
//             {isAdmin ? "Admin Command Center" : "Donor Transparency Portal"}
//           </div>
//         </div>

//         <nav className="flex-1 py-4 space-y-1 px-3">
//           {items.map((it) => (
//             <NavLink
//               key={it.to}
//               to={it.to}
//               end={it.to === "/admin" || it.to === "/donor"}
//               data-testid={it.testid}
//               className={({ isActive }) =>
//                 `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium
//                  transition-colors duration-150
//                  ${isActive
//                   ? "bg-[hsl(160,84%,17%)] text-white shadow-sm"
//                   : "text-slate-700 hover:bg-white hover:text-[hsl(160,84%,17%)]"}`
//               }
//             >
//               <it.icon className="w-4 h-4" />
//               <span>{it.label}</span>
//             </NavLink>
//           ))}
//         </nav>

//         <div className="px-3 pb-5 pt-3 border-t border-border">
//           <div className="px-3 py-3 rounded-lg bg-white/60">
//             <div className="text-[11px] uppercase tracking-widest text-emerald-800/70">Signed in</div>
//             <div className="mt-1 text-sm font-semibold truncate" data-testid="current-user-name">{user?.fullName}</div>
//             <div className="text-xs text-muted-foreground truncate">{user?.email}</div>
//             <button
//               onClick={logout}
//               data-testid="logout-btn"
//               className="mt-3 w-full inline-flex items-center justify-center gap-2 rounded-md border border-emerald-900/15 bg-white px-3 py-2 text-xs font-semibold text-emerald-900 hover:bg-emerald-50 transition-colors"
//             >
//               <LogOut className="w-3.5 h-3.5" /> Log out
//             </button>
//           </div>
//         </div>
//       </aside>

//       <div className="flex-1 min-w-0 flex flex-col">
//         <header className="md:hidden flex items-center justify-between px-4 py-3 border-b border-border bg-white">
//           <div className="font-display font-extrabold text-emerald-900">DRMS<span className="text-orange-600">.</span></div>
//           <button onClick={logout} data-testid="mobile-logout-btn" className="text-xs font-semibold text-emerald-900">Log out</button>
//         </header>
//         <main className="flex-1 min-w-0 p-6 lg:p-10 max-w-7xl w-full mx-auto">
//           {children}
//         </main>
//       </div>
//     </div>
//   );
// }



import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, Users, HandCoins, GitBranch, Wallet, HeartHandshake,
  Sparkles, LogOut, User as UserIcon, Receipt, Home, BarChart3, Download
} from "lucide-react";
// If using Vite/React module system, you can import the logo like this:
// import logoImg from "@/resources/impactVisionLogo.jpg";

import logoImg from "@/resources/impactVisionLogo.jpg";

const NAV_ADMIN = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, testid: "nav-admin-dashboard" },
  { to: "/admin/donors", label: "Donors", icon: Users, testid: "nav-admin-donors" },
  { to: "/admin/donations", label: "Donations", icon: HandCoins, testid: "nav-admin-donations" },
  { to: "/admin/projects", label: "Projects & Activities", icon: GitBranch, testid: "nav-admin-projects" },
  { to: "/admin/utilizations", label: "Fund Utilization", icon: Wallet, testid: "nav-admin-utilizations" },
  { to: "/admin/beneficiaries", label: "Beneficiaries", icon: HeartHandshake, testid: "nav-admin-beneficiaries" },
  { to: "/admin/impact", label: "Impact Updates", icon: Sparkles, testid: "nav-admin-impact" },
];

const NAV_DONOR = [
  { to: "/donor", label: "Dashboard", icon: Home, testid: "nav-donor-dashboard" },
  { to: "/donor/contributions", label: "My Contributions", icon: Receipt, testid: "nav-donor-contributions" },
  { to: "/donor/impact", label: "My Impact", icon: Sparkles, testid: "nav-donor-impact" },
  { to: "/donor/downloads", label: "Download Centre", icon: Download, testid: "nav-donor-downloads" },
  { to: "/donor/profile", label: "My Profile", icon: UserIcon, testid: "nav-donor-profile" },
];

export default function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const isAdmin = user?.role === "ADMIN";
  const items = isAdmin ? NAV_ADMIN : NAV_DONOR;

  return (
    <div className="min-h-screen flex bg-background text-foreground">
      <aside className="hidden md:flex md:w-72 flex-col border-r border-border bg-[#F7F4EF]/70 backdrop-blur">
        <div
          role="button"
          tabIndex={0}
          onClick={() => nav(isAdmin ? "/admin" : "/donor")}
          className="px-6 py-6 border-b border-border cursor-pointer"
          data-testid="brand-home-link"
        >
          {/* Logo and Brand Header Container */}
          <div className="flex items-center gap-3 mb-2">
            <img 
              src={logoImg} 
              alt="Impact Vision Logo" 
              className="w-15 h-15 object-contain rounded-md shadow-sm border border-border bg-white" 
            />
          </div>

          <div className="mt-1 font-display text-sm font-extrabold tracking-tight text-[hsl(160,84%,17%)]">
            DRMS Impact Vision 
            <span className="text-[hsl(30,91%,44%)]">.</span>
          </div>
          <div className="text-xs text-muted-foreground mt-1">
            {isAdmin ? "Admin Command Center" : "Donor Transparency Portal"}
          </div>
        </div>

        <nav className="flex-1 py-4 space-y-1 px-3">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.to === "/admin" || it.to === "/donor"}
              data-testid={it.testid}
              className={({ isActive }) =>
                `group flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium
                 transition-colors duration-150
                 ${isActive
                  ? "bg-[hsl(160,84%,17%)] text-white shadow-sm"
                  : "text-slate-700 hover:bg-white hover:text-[hsl(160,84%,17%)]"}`
              }
            >
              <it.icon className="w-4 h-4" />
              <span>{it.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="px-3 pb-5 pt-3 border-t border-border">
          <div className="px-3 py-3 rounded-lg bg-white/60">
            <div className="text-[11px] uppercase tracking-widest text-emerald-800/70">Signed in</div>
            <div className="mt-1 text-sm font-semibold truncate" data-testid="current-user-name">{user?.fullName}</div>
            <div className="text-xs text-muted-foreground truncate">{user?.email}</div>
            <button
              onClick={logout}
              data-testid="logout-btn"
              className="mt-3 w-full inline-flex items-center justify-center gap-2 rounded-md border border-emerald-900/15 bg-white px-3 py-2 text-xs font-semibold text-emerald-900 hover:bg-emerald-50 transition-colors"
            >
              <LogOut className="w-3.5 h-3.5" /> Log out
            </button>
          </div>
        </div>
      </aside>

      <div className="flex-1 min-w-0 flex flex-col">
        <header className="md:hidden flex items-center justify-between px-4 py-3 border-b border-border bg-white">
          <div className="flex items-center gap-2">
            <img 
              src="/src/resources/impactVisionLogo.jpg" 
              alt="Impact Vision Logo" 
              className="w-7 h-7 object-contain rounded" 
            />
            <div className="font-display font-extrabold text-emerald-900">DRMS<span className="text-orange-600">.</span></div>
          </div>
          <button onClick={logout} data-testid="mobile-logout-btn" className="text-xs font-semibold text-emerald-900">Log out</button>
        </header>
        <main className="flex-1 min-w-0 p-6 lg:p-10 max-w-7xl w-full mx-auto">
          {children}
        </main>
      </div>
    </div>
  );
}